// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MessageOutlinedSvg from "@fishx/icons-svg/es/asn/MessageOutlined";
import FishxIcon from '../components/FishxIcon';

var MessageOutlined = function MessageOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MessageOutlinedSvg
  }));
};

MessageOutlined.displayName = 'MessageOutlined';
export default React.forwardRef(MessageOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MessageOutlined.js
// module id = 3123
// module chunks = 0